import { render } from "./BackArrow.vue?vue&type=template&id=44ccad24&scoped=true"
import script from "./BackArrow.vue?vue&type=script&lang=js"
export * from "./BackArrow.vue?vue&type=script&lang=js"

import "./BackArrow.vue?vue&type=style&index=0&id=44ccad24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ccad24"]])

export default __exports__